<template>
    <bootstrap-box>
        <template v-slot:body>
            <advanced-sankey-diagram :initial-journey-id="initialJourneyId" />
        </template>
    </bootstrap-box>
</template>

<script>
    import BootstrapBox from "../../../Components/Util/BootstrapBox.vue";
    import AdvancedSankeyDiagram from "./Charts/AdvancedSankeyDiagram.vue";
    
    export default {
        name: 'journey-statistics-overview',
        components: {
            BootstrapBox,
            AdvancedSankeyDiagram
        },
        computed: {
            initialJourneyId(){
                const vm = this;
                
                if(vm.$route && vm.$route.params && vm.$route.params.id){
                    return vm.$route.params.id;
                }
                
                return undefined;
            }
        }
    }
</script>